<template>
  <div
    v-loading="!online"
    id="app"
    element-loading-text="警示! 网络异常, 请检查网络 ( 建议不要刷新或关闭浏览器，联线后程序将自动恢复 )"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    element-loading-custom-class="online-checker">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      online: true
    }
  },
  created() {
    // eslint-disable-next-line
    window.addEventListener('online', () => {
      this.online = true
    })
    // eslint-disable-next-line
    window.addEventListener('offline', () => {
      this.online = false
    })
  }
}
</script>

<style>
.el-form .help, .help {color:#999;}
.online-checker {
  z-index: 9999999;
}
.online-checker .el-loading-spinner i {
  font-size:24px;
  color: red;
}
.online-checker .el-loading-spinner .el-loading-text {
  margin-top: 15px;
  font-size:18px;
  color: red;
}
.bottom-container {
  text-align:center;
  padding:10px 0;
}
</style>
